import type * as API from '@trinity/chat/api/interfaces';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient.js';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';

type Params = API.Transcripts.DownloadConferenceTagClip.Request;

export const useDownloadTranscriptTagClip = (params: Params, options: Omit<UseDownloaderOptions<API.Transcripts.DownloadConferenceTagClip.Response>, 'queryKey' | 'queryFn'> = {}) => {

  const apiClient = useChatApiClient();

  return useQueryDownloader({
    queryKey: [
      `get:transcript/tag/clip`,
      params,
    ],
    queryFn: () => {
      return apiClient.transcripts.downloadTagClip({
        momentId: params.momentId,
        transcriptId: params.transcriptId,
      });
    },
    downloaderOptions: {
      onResponse: res => ({
        type: 'websocket',
        value: res.websocketKey,
      }),
    },
    ...options,
  });
};